var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigArrowRight28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.146 4.146a.5.5 0 0 1 .708 0l10 10a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708-.708l9.647-9.646-9.647-9.646a.5.5 0 0 1 0-.708Z",
  clipRule: "evenodd"
})));
export { SvgBigArrowRight28 as ReactComponent };
export default __webpack_public_path__ + "4b37e085f252bee9cb9ae665e0bee8be.svg";